import React, { useEffect, useState } from "react";
import ChartDoughnut from "../ui/ChartDoughnut";

const DashboardBloackB = ({ equityData }) => {
  const [selectedSector, setSelectedSector] = useState("Sectors");
  const [selectedEquity, setSelectedEquity] = useState();
  const [selectedEquityData, setSelectedEquitydata] = useState();
  const [chartKey, setChartKey] = useState(0);
  const sector = ["Sectors", "MES", "Industry"];

  const handleSector = () => {
    let sectorData = null;
    if (selectedSector === "Sectors") {
      sectorData = equityData && equityData["sector_percentages"];
    } else if (selectedSector === "MES") {
      sectorData =
        equityData && equityData["macro_economic_Sector_percentages"];
    } else if (selectedSector === "Industry") {
      sectorData = equityData && equityData["industry_percentages"];
    } else if (selectedSector === "Basic Industry") {
      sectorData = equityData && equityData["basic_industry_percentages"];
    }

    if (sectorData) {
      const sortedSectorData = {};
      Object.keys(sectorData)
        .sort((a, b) => {
          const valueA = parseFloat(sectorData[a]);
          const valueB = parseFloat(sectorData[b]);
          return valueB - valueA;
        })
        .forEach((key) => {
          sortedSectorData[key] = sectorData[key];
        });
      setSelectedEquity(sortedSectorData);
    }
  };
  useEffect(() => {
    handleSector();
  }, [equityData, selectedSector]);

  useEffect(() => {
    // let predefinedColors = [
    //   "#E01E84",
    //   "#C758D0",
    //   "#9C46D0",
    //   "#8E6CEF",
    //   "#8399EB",
    //   "#007ED6",
    //   "#97D9FF",
    //   "#5FB7D4",
    //   "#7CDDDD",
    //   "#26D7AE",
    //   "#2DCB75",
    //   "#1BAA2F",
    //   "#52D726",
    //   "#85A722",
    //   "#FFEC00",
    //   "#FFAF00",
    //   "#FF7300",
    //   "#FF0000",
    // ];

    let predefinedColors = [
      "#f29867",
      "#fcf26a",
      "#d1dd5c",
      "#30aa3f",
      "#5ac6c0",
      "#62c9ef",
      "#5c9fcd",
      "#5b4396",
      "#ac7ab2",
      "#cd5c99",
      "#eb5aa1",
      "#e00e31",
      "#f7bea1",
      "#fbf59c",
      "#e0e69a",
      "#7dc286",
      "#9ad8d5",
      "#9fdbf2",
      "#9cc4e2",
      "#9588bc",
      "#caabce",
      "#e19ec0",
      "#ef92bd",
      "#eb707e",
    ];

    // predefinedColors.reverse();

    const sortableArray =
      selectedEquity &&
      Object.entries(selectedEquity)?.map(([key, value]) => ({
        sector: key,
        percentage: value,
      }));

    if (sortableArray) {
      let sorted = sortableArray.sort((a, b) => b.percentage - a.percentage);

      const getNextColor = (index) => {
        const color = predefinedColors[index];
        return color;
      };

      let configDatas =
        sorted &&
        sorted.map(({ sector, percentage }, index) => ({
          label: sector,
          data: percentage,
          backgroundColor: getNextColor(index),
        }));

      if (configDatas) {
        setSelectedEquitydata(configDatas.sort((a, b) => b.data - a.data));
        setChartKey((prevKey) => prevKey + 1);
      }
    }
  }, [selectedEquity, selectedSector]);
  
  return (
    <div className="flex h-full flex-col items-stretch justify-between text-sm font-bold text-neutral-800">
      <div className="flex justify-between">
        <h2 className="inline-block"> Equity Overview </h2>
        <div>
          <select
            onChange={(e) => setSelectedSector(e.target.value)}
            className="bg-white text-sm font-medium text-neutral-800 outline-none"
          >
            {sector.map((item, i) => (
              <option value={item} key={i}>
                {item}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="mt-auto md:flex lg:flex items-center max-sm:justify-center lg:justify-evenly gap-2">
        <div className="w-[200px] justify-center max-sm:mx-auto max-md:mx-auto">
          {selectedEquityData && (
            <ChartDoughnut
              key={chartKey}
              centerText={selectedSector}
              configData={selectedEquityData}
              size={25}
            />
          )}
        </div>

        <div className="scrollbar-container h-[210px] w-full overflow-y-scroll px-4 ">
          {selectedEquityData &&
            selectedEquityData.map((data) => (
              <div
                key={data.label}
                className="flex items-center justify-between gap-3 "
              >
                <div className=" flex items-center gap-2 p-3">
                  <div
                    className="aspect-square w-[20px] rounded-full bg-red-400"
                    style={{ backgroundColor: data.backgroundColor }}
                  />
                  <div className="font-normal text-neutral-500">
                    {data.label}{" "}
                  </div>
                </div>

                <div> {(data?.data).toFixed(2)} %</div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardBloackB;
